import { render, staticRenderFns } from "./SelectSupplierNewPiece.vue?vue&type=template&id=2e654c74&scoped=true&lang=pug"
import script from "./SelectSupplierNewPiece.vue?vue&type=script&lang=js"
export * from "./SelectSupplierNewPiece.vue?vue&type=script&lang=js"
import style0 from "./SelectSupplierNewPiece.vue?vue&type=style&index=0&id=2e654c74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e654c74",
  null
  
)

export default component.exports